// eslint-disable-next-line no-restricted-imports
import Storage from 'common/lib/storage';

export const announcementsKey = (id: string) => {
  return `announcement-${id}-read`;
};

export interface Announcement {
  html: string;
  id: string;
  locale: string;
  title: string;
  type: string;
  url: string;
}

export const isUnread = (id: string) => !Storage.get(announcementsKey(id));

export const markRead = (id: string) =>
  Storage.set(announcementsKey(id), 'true');

export const getTacoShow = () => Storage.get('tacoShow');

export const clearTacoShow = () => Storage.unset('tacoShow');

export const setTacoShow = (date: number) =>
  Storage.set('tacoShow', date.toString());



// WEBPACK FOOTER //
// ./app/gamma/src/util/application-storage/announcements.ts